function redirect(url) {
    document.location.href = url;
}

function getCurrentUrl() {
    return document.location.href;
}

module.exports = {
    redirect: redirect,
    getCurrentUrl: getCurrentUrl
};


// WEBPACK FOOTER //
// ./App/services/redirect.js